export const LOADING_TEXT = 'Creating and retrieving your training...'
